import script from "./AuthRecoveryChangePassword.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthRecoveryChangePassword.vue?vue&type=script&setup=true&lang=js"

import "./AuthRecoveryChangePassword.vue?vue&type=style&index=0&id=d89f332e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d89f332e"]])

export default __exports__